<template>
    <v-card>
      <br/>
      <h2 class="font-weight-bold text-lg-center display-1">{{ message }}</h2>
      <v-card-text>
        Begins at: {{ begins }}<br/>
        {{ countdown }}
      </v-card-text>
    </v-card>
</template>

<script>
// Countdown message to a passed in start time. Emits an event when countdown is reached.

import moment from 'moment-timezone'

export default {
  name: 'Countdown',
  props: {
    message: {
      type: String,
      required: true
    },
    startTime: {
      // type: Date,
      required: true
    }
  },

  watch: {
    startTime: function () {
      const beginTime = new Date(this.startTime)
      const nowTime = new Date()
      if (beginTime <= nowTime) {
        this.minutesRemaining = 'Starting...'
      } else {
        const minutes = Math.floor((beginTime - nowTime) / 1000 / 60)
        this.minutesRemaining = minutes
        this.interval = setInterval(() => {
          if (this.minutesRemaining > 0) {
            this.minutesRemaining -= 1
            if (this.minutesRemaining === 0) {
              this.$emit('launch')
              this.interval = null
            }
          }
        }, 60000)
      }
    }
  },

  computed: {
    begins: function () {
      const beginTime = new Date(this.startTime)
      const nowTime = new Date()
      if (beginTime.toDateString() !== nowTime.toDateString()) {
        return beginTime.toDateString() + ', ' + beginTime.toTimeString()
      } else {
        let minutes = beginTime.getMinutes()
        let hours = beginTime.getHours()
        if (minutes.length < 10) {
          minutes = '0' + minutes
        }
        if (hours < 10) {
          hours = '0' + hours
        }
        return hours + ':' + minutes + ' ' + moment.tz.guess()
      }
    },
    countdown: function () {
      if (this.minutesRemaining > 0) {
        return this.minutesRemaining + ' minutes'
      } else {
        return 'Starting...'
      }
    }
  },

  data: function () {
    return {
      minutesRemaining: 0,
      interval: ''
    }
  }
}
</script>

<style scoped>

</style>
